<template>
  <div class="contain">
    <van-image v-if="backColorFlag" class="fiyImg" :src="objImg.backImg" />
    <headers :title="documentTitle"></headers>
    <div class="fiy">
      <div class="title">
        <h4>全部类型</h4>
        <div class="icon" @click="backlist">
          <van-icon name="arrow-up" />
        </div>
      </div>
      <p class="ticke">
        选择您关注的类型
        <span>点击进入频道</span>
      </p>
      <ul class="list_box">
        <li
          :class="
            backColorFlag
              ? `${index === Number(actives) ? 'activeTwo' : ''}`
              : `${index === Number(actives) ? 'active' : ''}`
          "
          v-for="(item, index) in list"
          :key="item.id"
          @click="tolists(index, item.id)"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script setup>
import backImg from "../../assets/image/C-back.png";
import headers from "../../components/header.vue";
import { getclassfiy } from "../../api/index.js";
import { ref, onBeforeMount } from "vue";
import { useRoute, useRouter } from "vue-router";
import useDataInfo from "../../store/index";
const dataInfo = useDataInfo();
const route = useRoute();
const router = useRouter();
const list = ref([]);
const documentTitle = ref("");
const actives = ref();
const backColorFlag = ref(); //背景图片和颜色改变的标识
const objImg = ref({
  backImg,
});
async function getclassfiyd() {
  const res = await getclassfiy(route.query.pid ? route.query.pid : 0);
  if (res.code === 1) {
    res.data.datalist.unshift({ id: 0, name: "全部" });
    list.value = res.data.datalist;
    documentTitle.value = res.data.title;
  }
}
const tolists = (index, id) => {
  switch (route.query.type) {
    case "WT":
      sessionStorage.setItem("coverId", id);
      router.push(`/?pid=${route.query.pid}`);
      break;

    default:
      sessionStorage.setItem("WXTabsIndex", index);
      router.push(`/?pid=${route.query.pid}`);
      break;
  }
};
const backlist = () => {
  router.push("/?pid=" + route.query.pid);
};
onBeforeMount(async () => {
  switch (route.query.type) {
    case "basis":
      actives.value = sessionStorage.getItem("WXTabsIndex");
      getclassfiyd();
      backColorFlag.value = false;
      break;
    case "first":
      actives.value = sessionStorage.getItem("WXTabsIndex");
      documentTitle.value = dataInfo.docuTitle;
      list.value = dataInfo.navList;
      backColorFlag.value = true;
      break;
    case "WT":
      await getclassfiyd();
      let id = sessionStorage.getItem("coverId");
      actives.value = list.value.findIndex((f) => f.id === Number(id));
      backColorFlag.value = true;
      break;
  }
});

defineExpose({});
</script>

<style lang="less" scoped>
@instent: 15px;

.fiyImg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}
.contain {
  background: #ededed;
  min-height: 100vh;
  overflow: hidden;
}
.fiy {
  position: relative;
  z-index: 1;
}
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 31px;
  padding: 0 @instent;
  h4 {
    font-size: 18px;
    color: #333333;
  }
  .icon {
    font-size: 20px;
  }
}
.ticke {
  font-size: 16px;
  color: #333333;
  padding: 0 @instent;
  margin-top: 48px;
  span {
    color: #a7a7a7;
    font-size: 12px;
    margin-left: 10px;
  }
}
.list_box {
  padding: 0 @instent;
  margin-top: 20px;
  li {
    float: left;
    height: 36px;
    line-height: 36px;
    border-radius: 5px;
    font-size: 14px;
    color: #3e3e3e;
    padding: 0 20px;
    background: #fff;
    margin-right: 15px;
    margin-bottom: 10px;
  }
  .active {
    background: #f3645e;
    color: #fff;
  }
  .activeTwo {
    background: #5672ff;
    color: #fff;
  }
}
</style>
